import { useTheme } from '@mui/material';

const useButtonTokens = () => {
  const theme = useTheme();

  return {
    primary: {
      default: {
        fg: {
          default: theme.palette.common.white,
          hover: theme.palette.common.white,
          active: theme.palette.common.white,
        },
        bg: {
          default: theme.palette.primary[600],
          hover: theme.palette.primary[500],
          active: theme.palette.primary[700],
        },
        border: {
          default: theme.palette.primary[600],
          hover: theme.palette.primary[500],
          active: theme.palette.primary[700],
        },
      },
      error: {
        bg: {
          default: theme.palette.dustRed[400],
          hover: theme.palette.dustRed[300],
          active: theme.palette.dustRed[500],
        },
        border: {
          default: theme.palette.dustRed[400],
          hover: theme.palette.dustRed[300],
          active: theme.palette.dustRed[500],
        },
      },
    },
    primaryColor: {
      default: {
        fg: {
          default: theme.palette.common.white,
          hover: theme.palette.common.white,
          active: theme.palette.common.white,
        },
        bg: {
          default: theme.palette.secondary[700],
          hover: theme.palette.secondary[600],
          active: theme.palette.secondary[800],
        },
        border: {
          default: theme.palette.secondary[700],
          hover: theme.palette.secondary[600],
          active: theme.palette.secondary[800],
        },
      },
      error: {
        bg: {
          default: theme.palette.dustRed[400],
          hover: theme.palette.dustRed[300],
          active: theme.palette.dustRed[500],
        },
        border: {
          default: theme.palette.dustRed[400],
          hover: theme.palette.dustRed[300],
          active: theme.palette.dustRed[500],
        },
      },
    },
    secondary: {
      default: {
        fg: {
          default: theme.palette.grey[700],
          hover: theme.palette.grey[700],
          active: theme.palette.grey[700],
          color: {
            default: theme.palette.primary[600],
            hover: theme.palette.primary[700],
            active: theme.palette.primary[800],
          },
        },
        bg: {
          default: theme.palette.common.white,
          hover: theme.palette.grey[25],
          active: theme.palette.grey[50],
          color: {
            default: theme.palette.common.white,
            hover: theme.palette.primary[50],
            active: theme.palette.primary[50],
          },
        },
        border: {
          default: theme.palette.grey[200],
          hover: theme.palette.grey[300],
          active: theme.palette.grey[300],
          color: {
            default: theme.palette.primary[200],
            hover: theme.palette.primary[300],
            active: theme.palette.primary[300],
          },
        },
      },
      error: {
        fg: {
          default: theme.palette.dustRed[400],
          hover: theme.palette.dustRed[500],
          active: theme.palette.dustRed[600],
        },
        bg: {
          default: theme.palette.common.white,
          hover: theme.palette.grey[25],
          active: theme.palette.dustRed[25],
        },
        border: {
          default: theme.palette.grey[200],
          hover: theme.palette.dustRed[300],
          active: theme.palette.dustRed[300],
        },
      },
    },
    tertiary: {
      default: {
        fg: {
          default: theme.palette.grey[700],
          secondary: theme.palette.grey[400],
          hover: theme.palette.grey[700],
          active: theme.palette.grey[700],
          color: {
            default: theme.palette.secondary[700],
            hover: theme.palette.secondary[800],
            active: theme.palette.secondary[800],
          },
        },
        bg: {
          default: theme.palette.common.white,
          hover: theme.palette.grey[50],
          active: theme.palette.grey[100],
          color: {
            default: theme.palette.common.white,
            hover: theme.palette.grey[50],
            active: theme.palette.secondary['700-8'], // secondary-700 with 8% opacity
          },
        },
      },
      error: {
        fg: {
          default: theme.palette.dustRed[400],
          hover: theme.palette.dustRed[500],
          active: theme.palette.dustRed[600],
        },
        bg: {
          default: theme.palette.common.white,
          hover: theme.palette.grey[50],
          active: theme.palette.dustRed[50],
        },
      },
    },
    link: {
      default: {
        fg: {
          default: theme.palette.grey[700],
          color: theme.palette.secondary[700],
          hover: theme.palette.grey[600],
          active: theme.palette.grey[700],
        },
      },
      error: {
        fg: {
          color: theme.palette.dustRed[400],
          hover: theme.palette.dustRed[500],
          active: theme.palette.dustRed[600],
        },
      },
    },
  };
};

export default useButtonTokens;
